import { useEffect, useState } from "react";
export var useIsMobile = function () {
    var _a = useState(false), isMobile = _a[0], setIsMobile = _a[1];
    useEffect(function () {
        var checkMobile = function () {
            // Check for touch capability
            var hasTouch = "ontouchstart" in window ||
                navigator.maxTouchPoints > 0 ||
                navigator.msMaxTouchPoints > 0;
            // Check user agent for mobile patterns
            var userAgent = navigator.userAgent.toLowerCase();
            var mobilePatterns = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
            var isMobileUA = mobilePatterns.test(userAgent);
            setIsMobile(hasTouch && isMobileUA);
        };
        checkMobile();
    }, []);
    return isMobile;
};
